loadingProgress({
  loadedFN: function() {
    $(".header").addClass("show");
    $("#app").addClass("loaded");
  },
  detectVideo: true
});

if ($(".downloads-notice__inner").length) {
  $(".downloads-notice__inner").mCustomScrollbar({
    theme: "light-3",
    scrollButtons: { enable: false },
    scrollInertia: 0,
    mouseWheelPixels: 50
  });
}

var videoObj = {
  addClass: "video-lb",
  hasCloseBtn: true,
  hasActionBtn: false,
  afterClose: function() {
    $.gbox.close();
  }
};

function videoHTMLRender(video) {
  var videoHTML =
    '<div class="lb-video-box">\
            <iframe width="560" height="315" src="' +
    video +
    '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>\
        </div>\
    ';
  return videoHTML;
}

$("body").on("click", ".movies-list__img-box", function() {
  var video = $(this).attr("data-video");
  // var videoId = video.split("=")[1]
  if (isMobile.any) {
    var _src = video;
    $(this).attr("target", "_blank");
    $(this).attr("href", _src);
  } else {
    $.gbox.open(videoHTMLRender(video), videoObj);
  }
});

$("body").on("click", ".movies-slider", function() {
  var seq = $(this).attr("data-seq");
  $(".movies-list__img-box")
    .parent("li")
    .removeClass("show");
  $(".movies-list__img-box[data-seq=" + seq + "]")
    .parent("li")
    .addClass("show");
});

// 選單開關
$("body").on("click", ".header-bar__open", function() {
  $(".nav-wrap").fadeIn(150);
});

$("body").on("click", ".nav-box__close", function() {
  $(".nav-wrap").fadeOut(150);
});

$(window).on("scroll", function() {
  var t = $(this).scrollTop();
  if ($(".main-nav").length > 0) {
    var mnavTop = $(".main-nav").offset().top + $(".main-nav").outerHeight();
    if ($(".home").length > 0 && !$(".main-nav").is(":hidden")) {
      if (t >= mnavTop) {
        $(".nav-wrap").fadeIn();
      } else {
        $(".nav-wrap").fadeOut();
      }
    }
  }
  if (t <= 100) {
    $(".page-top").removeClass("click");
  }
  $(".nav-wrap").css("left", -$(window).scrollLeft());
});

$(".downloads-ntitle__target").on("click", function() {
  var target = $(this).attr("data-target");
  $("body,html").animate({
    scrollTop:
      $(".downloads-notice-box[data-target=" + target + "]").offset().top -
      $(".nav-wrap").outerHeight()
  });
});

var comingSoonObj = {
  addClass: "commingSoon",
  hasCloseBtn: true,
  hasActionBtn: false,
  afterClose: function() {
    $.gbox.close();
  }
};

var comingSoonHTML = "<div class='commingSoon-wrap'>敬請期待</div>";

$(
  ".header-bar__download-app,.header-bar__download-goo,.bottom-desc__dl-app,.bottom-desc__dl-goo,.main__downloadapp-app,.main__downloadapp-goo"
).on("click", function() {
  var _href = $(this).attr("href");
  if (_href === "javascript:;") {
    $.gbox.open(comingSoonHTML, comingSoonObj);
  }
});
